import React from 'react';
import { bool, string } from 'prop-types';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';
import axaLogo from '../../assets/axa-logo.png';
import MaterialSymbol from '../MaterialSymbol/MaterialSymbol';

import css from './InsuredByAxaBadge.module.css';

/**
 * "Anfitriones asegurados" AXA badge (shield + label + AXA logo), reusable across
 * surfaces (footer, listing wizard, …). Optionally shows the legal disclaimer
 * below it. Reuses the SectionFooter.* i18n keys so the copy stays single-sourced.
 */
const InsuredByAxaBadge = props => {
  const { className, rootClassName, showDisclaimer, href } = props;
  const classes = classNames(rootClassName || css.root, className);

  const badge = (
    <div className={css.badge}>
      <MaterialSymbol name="shield" className={css.shield} size={24} />
      <span className={css.badgeText}>
        <FormattedMessage id="SectionFooter.insuredHostsBadge" />
      </span>
      <img src={axaLogo} alt="AXA" className={css.logo} />
    </div>
  );

  return (
    <div className={classes}>
      {href ? (
        <a className={css.link} href={href} target="_blank" rel="noopener noreferrer">
          {badge}
        </a>
      ) : (
        badge
      )}
      {showDisclaimer ? (
        <p className={css.disclaimer}>
          <FormattedMessage id="SectionFooter.insuranceDisclaimer" />
        </p>
      ) : null}
    </div>
  );
};

InsuredByAxaBadge.defaultProps = {
  className: null,
  rootClassName: null,
  showDisclaimer: false,
  href: null,
};

InsuredByAxaBadge.propTypes = {
  className: string,
  rootClassName: string,
  showDisclaimer: bool,
  href: string,
};

export default InsuredByAxaBadge;
